import { Component } from 'preact';
import PropTypes from 'prop-types';

class ButtonLoadMore extends Component {
  render() {
    return (
      <div className="button-load-more__wrapper">
        <button
          className="button btn button--outline button--load-more used-vehicles-listing__button-load-more"
          type="button"
          onClick={this.props.handleLoadMore}
        >
          {this.props.loadingMore ? (
            <span>Carregando...</span>
          ) : (
            <span>Ver mais ofertas</span>
          )}
        </button>
      </div>
    );
  }
}

ButtonLoadMore.defaultProps = {
  loadingMore: false,
  handleLoadMore: () => {},
};

ButtonLoadMore.propTypes = {
  loadingMore: PropTypes.bool,
  handleLoadMore: PropTypes.func,
};

export default ButtonLoadMore;
